<template>
  	<div class="stores" style="height:100%">
    	<div class="breadcrumb">模式化运动 > AI心率模式</div>
        <div class="hall-search-list">
			<el-button size='small' type="primary" @click="add" plain v-has="'course_list_add'">新增</el-button>
			<!-- <span class="hall-search-name">课程名称：</span>
            <input type="text" style="width:300px;" placeholder="请输入课程名称" class="el-input__inner" v-model="courseName" @keyup.enter="search_mine()"/>
            <span class="hall-search-name">教练选择：</span>
			<el-select v-model="coachId" placeholder="请选择" @change="search_mine">
				<el-option label="全部" value=""></el-option>
                <el-option
                    v-for="item in coachesData" 
                    :key="item.id"
                    :label="item.coachName"
                    :value="item.id">
                </el-option>
            </el-select>
            <span class="hall-search-name">课程时间：</span>
            <el-date-picker
                v-model="timeVal"
                type="daterange"
                range-separator=" 至 "
                start-placeholder="课程开始日期"
                end-placeholder="课程结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
            <span class="hall-search-line"></span>
	    	<el-button type="primary" @click="search_mine()">搜索</el-button> -->
		</div>
        <!-- <div style="padding:10px 0">
            <el-tabs v-model="activeName" @tab-click="topnav">
                <el-tab-pane label="全部" name="-1"></el-tab-pane>
                <el-tab-pane v-for="(item,index) in selData" :key="index" :label="item.name" :name="index+''"></el-tab-pane>
             </el-tabs>
        </div> -->
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" border :data="tableData" style="width: 100%" header-cell-class-name="table-header">
			        <el-table-column prop="name"  label="名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="levelName"  label="强度" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="calorie"  label="消耗" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="sportsKindName"  label="运动类型名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="sort"  label="排序" show-overflow-tooltip></el-table-column>
			        <el-table-column label="操作" width="280" align="center">
			        	<template slot-scope="scope">
                            <el-button v-has="'course_list_stage'"
                                    @click="stage(scope.row)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-claim">阶段</el-button>
                            <el-button v-has="'course_type_update'"
                                    @click="edit(scope.row)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-order">编辑</el-button>
                            <el-switch
                                v-has="'course_switch'" 
                                v-model="scope.row.isDelete == 0 ? true : false"
                                active-color="#13ce66"
                                inactive-color="#eeeeee"
                                active-text="上架"
                                inactive-text="下架"
                                @change="updatesw(scope.$index, scope.row.modeId, scope.row.isDelete)"
                            >
                            </el-switch>
                        </template>
			        </el-table-column>
		        </el-table>
	      	</template>
	      	<!-- <div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div> -->
	    </div>
	    <!-- 添加修改弹框 -->
	    <el-dialog :title="courseTitle" :visible.sync="dialogVisible" width="50%" top="10%">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="140px">
		        <el-form-item label="名称" prop="name">
		          	<el-input v-model="ruleForm.name" placeholder="请输入名称" style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="消耗" prop="calorie">
		          	<el-input v-model="ruleForm.calorie" placeholder="请输入消耗" style="width: 80%;" type="number"></el-input>
		        </el-form-item>
                <el-form-item label="强度">
                  <el-radio-group v-model="ruleForm.level">
                    <el-radio :label="1">初级</el-radio>
                    <el-radio :label="2">中级</el-radio>
                    <el-radio :label="3">高级</el-radio>
                  </el-radio-group>
		        </el-form-item>
                <el-form-item label="是否收费">
                  <el-radio-group v-model="ruleForm.chargeStatus">
                    <el-radio :label="1">免费</el-radio>
                    <el-radio :label="0">收费</el-radio>
                  </el-radio-group> 
		        </el-form-item>
                <el-form-item label="排序">
		          	<el-input v-model="ruleForm.sort" placeholder="排序" style="width: 80%;" type="number"></el-input>
                    <p style="font-sise:12px;color:red;">数字越小越靠前</p>
		        </el-form-item>
                <el-form-item label="点播课">
                  <el-radio-group v-model="ruleForm.chargeStatus">
                    <el-radio :label="1">限免</el-radio>
                    <el-radio :label="0">VIP</el-radio>
                  </el-radio-group>
		        </el-form-item>
                <el-form-item label="说明">
	          		<el-input type="textarea" v-model="ruleForm.modeDesc" style="width:80%" :rows="4"></el-input>
	        	</el-form-item>
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSave()">确 定</el-button>	
	      	</span>
	    </el-dialog>
	    <!-- 阶段弹框 -->
	    <el-dialog title="阶段" :visible.sync="dialogVisible3" width="90%" top="40px" class='stagecon'>
            <div>
                <div style="padding:10px;">
				    <el-button type="primary" @click="addLine" plain>添加行</el-button>
                </div>
                <div class="drag-table">
                    <table>
                        <tr class="header">
                                <td style="width:10%">拖动</td>
                                <td style="width:15%">阶段</td>
                                <td style="width:15%">分钟</td>
                                <td style="width:15%">秒数</td>
                                <td style="width:15%">运动状态</td>
                                <td style="width:15%">心率区间</td>
                                <td style="width:15%">操作</td>
                            </tr>
                    </table>
                    <table>
                        <vuedraggable v-model="coursePhaseData" animation="500"  force-fallback="true"  handle=".move"   @update="datadragEnd">
                            <tr v-for="(item,index) in coursePhaseData" :key="item.phase">
                                    <td style="width:10%" class="move">
                                        <i class="el-icon-sort" style="font-size:30px;color:#f56c6c;margin-top:6px;"></i>
                                    </td>
                                    <td style="width:15%">{{item.phase}}</td>
                                    <td style="width:15%">
                                        <el-input v-model="item.minutes"></el-input>  
                                    </td>
                                    <td style="width:15%">
                                        <el-input v-model="item.seconds"></el-input>
                                    </td>
                                    <td style="width:15%">
                                        <el-select v-model="item.stateId" placeholder="运动状态">
                                            <el-option :label="val.stateName" :value="val.id" v-for="val in stateList" :key="val.id"></el-option> 
                                        </el-select>
                                    </td>
                                    <td style="width:15%">
                                        <el-select v-model="item.intervalId" placeholder="心率区间">
                                            <el-option :label="val.name" :value="val.id" v-for="val in heartRate" :key="val.id"></el-option>
                                        </el-select>
                                    </td>
                                    <td  style="width:15%">
                                        <p style="display:flex;padding: 0 10px;justify-content: space-around;">
                                            <el-popconfirm title="请选择复制方式" confirm-button-text="向上复制" cancel-button-text="向下复制" @cancel="stageCopy(item,index,2)" @confirm="stageCopy(item,index,1)">
                                                <el-button
                                                    slot="reference"
                                                    type="text"
                                                    size="small"
                                                    icon="el-icon-update">复制</el-button>
                                            </el-popconfirm>
                                            <el-popconfirm title="确定删除吗？" @confirm="delLine(index)">
                                                <el-button v-has="'course_type_delete'"
                                                    slot="reference"
                                                    type="text"
                                                    size="small"
                                                    style="color:red;"
                                                    icon="el-icon-delete">删除</el-button>
                                            </el-popconfirm>
                                        </p>
                                    </td>
                                </tr>
                        </vuedraggable>
                    </table>
                    
                </div>
            </div>
	      	<div style="padding:20px 0 0">总时长：{{totalTime}}秒</div>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible3 = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
	      	</span>
	    </el-dialog>
  	</div>
</template>  
<script>
import vuedraggable from 'vuedraggable';
export default {
    components: {vuedraggable},
    mounted() {
        this.page();
    },
    data() {
        return {
            tableData: [], //初始化表格
            dialogVisible: false,
            courseEditId:'',
            courseTitle:'',
            ruleForm: {
                name:'',
                calorie:'',
                level:1,
                modeDesc:'',
                sportsKindId:2,
                chargeStatus:0,
                sort:''
            },
            ruleForms: {
                name: [{ required: true, message: '请输入名字',trigger:'blur'}],
                calorie: [{ required: true, message: '请输入消耗',trigger:'blur'}]
            },
            coursePhaseData: [],
            stateList:[],
            heartRate:[],
            dialogVisible3: false,
            stageSection:{
                minutes: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'分钟错误'},//分
                seconds: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'秒错误'},//秒
                stateId:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'运动状态'},//最小步频
                intervalId:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'心率区间'},//最大步频：
            }
        };
    },
    computed: {
        //计算时长
        totalTime: function() {
            let endTotal = 0;
            let that = this;
            for (let i = 0; i < that.coursePhaseData.length; i++) {
                if (that.coursePhaseData[i].seconds) {
                    endTotal += parseInt(that.coursePhaseData[i].seconds);
                }
            }
            let startTotal = 0;
            for (let i = 0; i < that.coursePhaseData.length; i++) {
                if (that.coursePhaseData[i].minutes) {
                    startTotal += parseInt(that.coursePhaseData[i].minutes);
                }
            }
            var totalTime2 = parseInt(startTotal * 60) + parseInt(endTotal);
            return that.global.formatSecond(totalTime2);
        },
        coachesChoice:function(){
            let arr=[];
            this.coachesData.forEach(item=>{
                this.checkCoachesList.forEach(val=>{
                    if(item.id == val){
                        arr.push(item)
                    }
                })
            })
            return arr;
        },
    },
    filters: {
        formatDate: function(value) {
            let date = new Date(value);
            let h = date.getHours();
            h = h < 10 ? '0' + h : h;
            let m = date.getMinutes();
            m = m < 10 ? '0' + m : m;
            let s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return h + '时' + m + '分' + s;
        }
    },
    methods: {
        //初始化表格数据
        page() {
            this.$get('/hrMode/list')
                .then(res => {
                    if (res.code == 0) {
                        this.tableData = Array.isArray(res.data)?res.data:[];
                    } else {
                        this.$message.error(res.message);
                    }
                })
        },
        edit(data) {
            const ruleForm={
                name:data.name,
                calorie:data.calorie,
                level:data.level,
                modeDesc:data.modeDesc,
                sportsKindId:data.sportsKindId,
                chargeStatus:data.chargeStatus,
                sort:data.sort
            };
            this.courseEditId=data.modeId;
            this.courseTitle='编辑';
            this.ruleForm=ruleForm;
            this.dialogVisible=true;
        },
        //添加
        add() {
            const ruleForm={
                name:'',
                calorie:'',
                level:1,
                modeDesc:'',
                sportsKindId:2,
                chargeStatus:0,
                sort:''
            };
            this.courseEditId=null;
            this.courseTitle='新增';
            this.ruleForm=ruleForm;
            this.dialogVisible=true;
        },
        onSave() {
             this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    const method=this.courseEditId?this.$put:this.$post;
                    const url=this.courseEditId?'/hrMode/edit/' + this.courseEditId:'/hrMode/add'
                     const loading = this.$loading({ text: "加载中..." });
                    if(this.courseEditId)this.ruleForm.id=this.courseEditId;
                    method(url, this.ruleForm)
                        .then(res => {
                            if (res.code == 0) {
                                this.$message.success('操作成功');
                                this.dialogVisible = false;
                                this.page();
                            } else {
                                this.$message.error(res.message);
                            }
                            loading.close();
                        })
                        .catch(() => {
                            loading.close();
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //点击阶段
        stage(data) {
            this.courseEditId=data.modeId;
            this.$get('/hrMode/phase/list?modeId='+data.modeId).then(res => {
                if (res.code == 0) {
                    let list = Array.isArray(res.data)?res.data:[],arr=[];
                    list.forEach(item=>{
                        arr.push({
                            minutes: Math.floor(item.duration/60),
                            seconds:item.duration%60,
                            ...item,
                        })
                    })
                    this.coursePhaseData=arr;
                    this.dialogVisible3=true;
                }else{
                    this.$message.error(JSON.stringify(res.message));
                }
            });
            
            // 查询AI心率区间列表
            this.$get('/hrMode/hrInterval/list').then(res => {
                if (res.code == 0) {
                    this.heartRate = Array.isArray(res.data)?res.data:[];
                }else{
                    this.$message.error(JSON.stringify(res.message));
                }
            });

            // 查询AI心率运动状态列表
            this.$get('/hrMode/state/list').then(res => {
                if (res.code == 0) {
                    this.stateList = Array.isArray(res.data)?res.data:[];
                }else{
                    this.$message.error(JSON.stringify(res.message));
                }
            });
        },

        addLine() {
            //添加行数
            let newValue = {
               modeId: this.courseEditId,
               phase:this.coursePhaseData.length+1,
            },addListJson=Object.keys(this.stageSection);
            addListJson.forEach(item=>{
                newValue[item]='';
            })
            //添加新的行数
            this.coursePhaseData.push(newValue);
        },
        delLine(index) {
            //删除行数
            this.coursePhaseData.splice(index,1)
        },
        stageCopy(data,index,flag){
            // flag 1 向上复制 2,向下复制
            let pushData=this.$_.cloneDeep(this.coursePhaseData)
            if(flag == 1){
                pushData.splice(index,0,data)
            }else{
                pushData.splice(index+1,0,data)
            }
           pushData.forEach((item,index)=>{
                item.phase=index+1;
            })
            this.coursePhaseData=pushData;
        },
        onSubmit() {
            var istrue = true,msg='',addListJson=this.stageSection,rowNum;
            this.coursePhaseData.map((item,index) => {
                let keys=Object.keys(item)
                for(let i in addListJson){
                    if (keys.includes(i) && addListJson[i].reg && !addListJson[i].reg.test(item[i])) {
                        istrue = false;
                        msg=addListJson[i].msg;
                        rowNum=index+1;
                        break;
                    }
                }
            });
            if(istrue === false) return this.$message.error(`第${rowNum}行${msg}`);
            const loading = this.$loading({ text: "加载中..." });
            this.coursePhaseData.forEach(item=>{
                item.duration=Number(item.minutes)*60+Number(item.seconds);
            })
            if (istrue == true) {
                this.$post('/hrMode/phase/add/' + this.courseEditId, this.coursePhaseData)
                    .then(res => {
                        if (res.code == 0) {
                            this.$message.success('保存成功');
                            this.dialogVisible3 = false;
                            this.page()
                        } else {
                            this.$message.error(res.message);
                        }
                        loading.close();
                    })
            }
        },
        datadragEnd(e){
            this.coursePhaseData.forEach((item, index) => {
                item.phase=index+1;
            });
        },
        updatesw(index, id, status) {
            if (!id) return this.$message.error("课程列表错误");
            const url = status == 0 ? "/hrMode/close/" : "/hrMode/open/";
            const loading = this.$loading({ text: "加载中..." });
            this.$put(url+id)
                .then((res) => {
                if (res.code == 0) {
                    this.$message.success("操作成功");
                    this.tableData[index].isDelete = status == 1 ? 0 : 1;
                } else {
                    this.$message.error(JSON.stringify(res.message));
                }
                loading.close();
                })
                .catch((err) => {
                this.$message.error(JSON.stringify(err));
                loading.close();
                });
        }
    }
};
</script>

<style scoped>
::deep .avatar-uploader-icon {
    width: 108px;
    line-height: 108px;
}
.selectUser {
    color: #409eff;
}
.selectUser label,
.selectUser i {
    font-size: 12px;
}

::deep .stagecon .el-dialog__body {
    padding: 10px 20px;
}
::deep .el-date-editor .el-range-separator {
    padding: 0;
}
.searchBtn .el-range-editor.el-input__inner {
    margin: 0 15px;
}
.topinput {
    position: relative;
    margin-left: 15px;
    width: 250px;
}
.topinput input {
    font-size: 13px;
}
.nickNameul {
    position: absolute;
    background: #fff;
    width: 100%;
    padding: 10px;
    font-size: 13px;
    line-height: 25px;
    border: 1px solid #dcdfe6;
    border-top: none;
}
.nickNameul li {
    color: #666;
    cursor: pointer;
}
.nickNameul li:hover {
    color: #409eff;
}
.coaches-list{
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
}
.coaches-list-item{
    width: 25%;
    padding:6px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.eachart-box{
    padding-left:120px;
    position: relative;
}
.eachart-box-bar{
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    width: 120px;
}
.eachart-box-progress{ 
    display: flex;
    align-items: center;
}
.eachart-box-progress-text{
    font-size: 12px;
    color:#333;
    flex:1;
    text-align: right;
    padding-right: 4px;
}
.eachart-box-progress-line{
    width: 8px;
    height: 100%;
}
.drag-col{
    padding:4px;
    height: 30px;
    text-align: center;
    font-size: 14px;
    color:#333;
    font-weight: bold;
    line-height: 30px;
}
.drag-table{
    width: 100%;
}
.drag-table table{
    width: 100%;
    border-collapse: collapse;
}
.drag-table table tr td{
    text-align: center;
    border:1px solid #eee;
    height: 40px;
    line-height: 40px;
    padding:3px;
}
.drag-table .header{
    width: 100%;
}
.drag-table .header td{
    font-size: 14px;
    font-weight: bold;
    color:#666;

}
.drag-table table div{
   display: inline-table;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/smartModeList/hrModeList.vue